module.exports = __webpack_public_path__ + "img/Ideen_Mezcla Brava.ff67ac7f.png";